import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

import { getImageReportList } from 'models/imageReport';
import { checkAuthGuard } from 'models/auth';
import { ROUTE_PATHS } from 'models/sideMenu';

const routes: CustomRoute = {
	path: '/image-report',
	components: () => [import(/* webpackChunkName: 'imageReport' */ './component')],
	render: ([ImageReport]) => <ImageReport />,
	onEnter: async ({ store }) => {
		const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.IMAGE_REPORT}`);
		if (allowEnter) {
			await store.dispatch(getImageReportList('OBSGYN/PED', 'Ultrasound', ''));
		}
	},
};

export default routes;
